<template>
	<div class="main">
		<div class="row">
			<div class="col-md-4">
			</div>
			<div class="col-md-4 text-center">
				<h3>{{ $t('Services') }}</h3>
			</div>
			<div class="col-md-4 text-right">
				<router-link v-if="$session.user.isAdmin" class="btn btn-info" to="/services/new">{{ $t('New') }}</router-link>
			</div>
		</div>
		<hr />
		<div class="form-group">
			<label>{{ $t('Filter') }}</label>
			<input type="text" class="form-control" v-model="criteria" />
		</div>
		<br/>
		<table class="table table-striped">
			<thead>
				<tr>
					<th class="col-md-1">{{ $t('Method') }}</th>
					<th class="col-md-3">URL</th>
					<th class="col-md-6">{{ $t('Description') }}</th>
					<th class="col-md-2"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="service of filter(services, criteria)" v-bind:key="service.idService">
					<td><span class="label label-default">{{ service.method }}</span></td>
					<td>{{ service.url }}</td>
					<td>{{ service.description }}</td>
					<td class="text-right">
						<router-link v-if="$session.user.isAdmin" v-bind:to="'/services/' + service.idService + '/edit'" class="btn btn-default"><span class="fa fa-edit"></span></router-link>
						<router-link v-bind:to="'/services/' + service.idService" class="btn btn-default"><span class="fa fa-search"></span></router-link>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		servicesService: {
			type: Object,
		},
	},
	data() {
		return {
			services: [],
			criteria: ""
		};
	},
	methods: {
		filter (services, criteria) {
			return services.filter(service => service.description.toLowerCase().includes(criteria.toLowerCase()) || service.url.toLowerCase().includes(criteria.toLowerCase()));
		}
	},
	async created() {
		this.services = await this.servicesService.getServices();
	},
};
</script>

<style>
.main {
	padding: 30px;
}
.text-right {
	text-align: right;
}
a {
	margin-left: 5px;
}
</style>
